import { c as _c } from "react/compiler-runtime";
import { BookingBox } from '@7f-ui/components/booking-box/booking-box';
import { Button } from '@7f-ui/components/button/button';
import { StickyFooter } from '@7f-ui/components/sticky-footer';
import { useMediaState } from '@7f-ui/hooks/use-media-state';
import { getMapUrl } from '@feat/feat-map/urls';
import { useUrlState } from '@feat/feat-url-state/use-url-state';
import { circleToPolygon, ProductType } from '@utils/helpers';
import Link from 'next/link';
import type { AccommodationFragment } from 'src/lib/backend/documents/accommodation';
type Props = {
  accommodation: Pick<AccommodationFragment, 'lat' | 'lng'>;
};
export function AccommodationUnavailableBox(t0) {
  const $ = _c(11);
  const {
    accommodation
  } = t0;
  const isMobile = useMediaState("mobile");
  const {
    urlState
  } = useUrlState();
  let t1;
  if ($[0] !== accommodation.lat || $[1] !== accommodation.lng || $[2] !== urlState.from || $[3] !== urlState.to) {
    const polygon = circleToPolygon({
      lat: accommodation.lat,
      lng: accommodation.lng
    }, 50);
    t1 = getMapUrl({
      polygon,
      from: urlState.from,
      to: urlState.to,
      productType: ProductType.ACCOMMODATION
    });
    $[0] = accommodation.lat;
    $[1] = accommodation.lng;
    $[2] = urlState.from;
    $[3] = urlState.to;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const link = t1;
  let t2;
  if ($[5] !== link) {
    t2 = {
      children: "Andere finden",
      href: link,
      as: Link
    };
    $[5] = link;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const buttonProps = t2;
  let t3;
  if ($[7] !== buttonProps || $[8] !== isMobile || $[9] !== link) {
    t3 = isMobile ? <StickyFooter buttonProps={buttonProps}><p className="flex h-full items-center text-balance font-base-copy">{"Leider ist es gerade nicht m\xF6glich, diese Unterkunft zu buchen."}</p></StickyFooter> : <div className="sticky-top-offset-12 sticky"><BookingBox><div className="space-y-2"><BookingBox.Title>{"Leider ist es gerade nicht m\xF6glich, diese Unterkunft zu buchen."}</BookingBox.Title><p className="font-base-copy">Entdecke weitere Unterkünfte in der Nähe.</p></div><Button as={Link} href={link} size="responsive">Unterkünfte in der Nähe</Button></BookingBox></div>;
    $[7] = buttonProps;
    $[8] = isMobile;
    $[9] = link;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}